import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
const blockListItemTextStyles = ({ theme }) => css `
	grid-area: text;
	margin: 0;
	max-width: none;
	color: ${theme.colors.base.textBody};

	a {
		color: ${theme.colors.highlight.textLink};
		text-decoration: underline;
	}
`;
export const StyledBlockListItemText = styled(Typography).attrs({
    variant: 'body-text',
}) `
	${blockListItemTextStyles}
`;
